import { render } from "./footer.vue?vue&type=template&id=719d140d&scoped=true&ts=true"
import script from "./footer.ts?vue&type=script&lang=ts"
export * from "./footer.ts?vue&type=script&lang=ts"

import "./footer.scss?vue&type=style&index=0&id=719d140d&lang=scss&scoped=true"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719d140d"]])

export default __exports__